const outboundRoutes = [
    {
        path: '/outboundOrderCreate',
        name: 'outboundOrderCreate',
        component: () => import('../../views/outbound/OutboundOrderCreate.vue'),
        meta: { title: '出库单创建' }
    },
    {
        path: '/outboundOrderList',
        name: 'outboundOrderList',
        component: () => import('../../views/outbound/OutboundOrderList.vue'),
        meta: { title: '出库单列表', hidden: true }
    },
    {
        path: '/todayOutboundOrders',
        name: 'todayOutboundOrders',
        component: () => import('../../views/outbound/TodayOutboundOrders.vue'),
        meta: { title: '今日出库单' }
    },
    {
        path: '/abnormalOutboundOrders',
        name: 'abnormalOutboundOrders',
        component: () => import('../../views/outbound/AbnormalOutboundOrders.vue'),
        meta: { title: '异常出库订单', hidden: true }
    },
    {
        path: '/scanningCheckout',
        name: 'scanningCheckout',
        component: () => import('../../views/outbound/ScanningCheckout.vue'),
        meta: { title: '扫描打单' }
    }
]

export default outboundRoutes

